import { APIClient } from "../apiCore";
import * as url from "../urls";

const api = new APIClient();

export interface OAuthScopeType {
    scope: string;
    description: string;
}

export interface OAuthAuthorizeRequestType {
    client: {
        id: string;
        name: string;
        // True only when every registered redirect URI is on a known MCP
        // client host (claude.ai, chatgpt.com…). Otherwise the name is just
        // what the registrant typed.
        verified: boolean;
    };
    redirectHost: string | null;
    redirectUri: string | null;
    account: string | null;
    scopes: OAuthScopeType[];
}

export interface OAuthGrantType {
    clientId: string;
    name: string;
    // The known MCP client host (claude.ai, chatgpt.com) every redirect URI of
    // the client points at, or null. The only safe basis for showing a logo.
    verifiedHost: string | null;
    connectedUntil: string;
}

// A pending /oauth/authorize request, parked by m9s-id until the user decides.
const getOAuthAuthorizeRequest = (requestId: string) => {
    return api.get(url.OAUTH_AUTHORIZE_REQUEST + '/' + encodeURIComponent(requestId) + '?_t=' + new Date().getTime());
};

// Resolves to {success, redirectUrl}: where to send the browser next, whether
// the user approved or denied.
const decideOAuthAuthorizeRequest = (requestId: string, approve: boolean) => {
    return api.create(url.OAUTH_AUTHORIZE_REQUEST + '/' + encodeURIComponent(requestId), {approve});
};

const getOAuthGrants = () => {
    return api.get(url.OAUTH_GRANTS + '?_t=' + new Date().getTime());
};

const revokeOAuthGrant = (clientId: string) => {
    return api.delete(url.OAUTH_GRANTS + '/' + encodeURIComponent(clientId));
};

export {
    getOAuthAuthorizeRequest,
    decideOAuthAuthorizeRequest,
    getOAuthGrants,
    revokeOAuthGrant,
};
